import { render, staticRenderFns } from "./PublishedChip.vue?vue&type=template&id=5ddf0d81"
import script from "./PublishedChip.vue?vue&type=script&lang=js"
export * from "./PublishedChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports